module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/institutions/icon_arrow--gray-d5afcef128fc0f7e03018c3cc87fa74a.svg";